import React, { memo, useEffect, useState } from "react";
import ToggleView from "./ToggleView";
import GridView from "./GridView";
import ListView from "./ListView";

export const LIST = "list";
export const GRID = "grid";

const CollectionsContainer = ({ contentfulCollections, vendor }) => {
  const [activeView, setActiveView] = useState(GRID);

  return (
    <div className="w-full border-inherit">
      <div className="w-full border-inherit">
        <ToggleView activeView={activeView} setActiveView={setActiveView} />
        {activeView === GRID ? (
          <GridView
            top={contentfulCollections.top}
            middle={contentfulCollections.middle}
            bottom={contentfulCollections?.bottom || []}
            promo1={contentfulCollections.promo1}
            promo2={contentfulCollections.promo2}
            vendor={vendor}
          />
        ) : (
          <ListView
            top={contentfulCollections.top}
            middle={contentfulCollections.middle}
            bottom={contentfulCollections?.bottom || []}
            promo1={contentfulCollections.promo1}
            promo2={contentfulCollections.promo2}
            vendor={vendor}
          />
        )}
      </div>
    </div>
  );
};

export default memo(CollectionsContainer);
